module.exports = __webpack_public_path__ + "img/photo14.1f50bab7.jpg";